(function (app, ng) {
    /*
     * This service will provide an empty object (or empty array in LoadArray) to be immediately returned (in a resolve typically) and later popupated with data
     * A boolean property is added to the value: $resolved, which can be used to help rendering: <div class="loading-icon" ng-show="obj.$resolved"></div>
     * Additionally, a property $promise is added, if the receiver is interested in it
     * idea taken from the way ngResource does it
     Usage: 
     resolve: {
        something: ["SomeAPI", function(SomeAPI) {
            return SomeAPI.SlowQuery();
        }]
     }
     
     --- becomes -->

     resolve: {
        something: ["SomeAPI", "Later", function(SomeAPI, Later) {
            return Later.LoadObject(SomeAPI.SlowQuery());
        }]
     }
     */
    app.provider("laterLoad", [function () {
        this.$get = ["$q", function ($q) {
            return {
                loadObject: loadObject,
                loadArray: loadArray
            };

            function loadObject(promise) {
                var obj = { $resolved: false, $rejected: false, $completed: false };
                obj.$promise = $q.when(promise).then(function (resultObj) {
                    ng.extend(obj, { $resolved: true, $completed: true }, resultObj);
                    return obj;
                }, function(error) {
                    ng.extend(obj, { $rejected: true, $completed: true }, error);
                    return obj;
                });
                return obj;
            }

            function loadArray(promise) {
                var arr = [];
                arr.$resolved = false;
                arr.$rejected = false;
                arr.$completed = false;
                arr.$promise = $q.when(promise).then(function (resultArr) {
                    arr.$resolved = true;
                    arr.$completed = true;
                    ng.forEach(resultArr, function (val) {
                        arr.push(val);
                    });
                    return arr;
                }, function(error) {
                    ng.extend(arr, { $rejected: true, $completed: true }, error);
                    return arr;
                });
                return arr;
            }
        }];
    }]);
    
})(window.app, window.angular); // jshint ignore:line